import { Controller } from "@hotwired/stimulus";
import { parseSignature } from "viem";
import walletService from "../../../services/WalletService";
import { emitCheckoutEvent } from "../../../services/checkoutEvents";
import { storage } from "../../../storageconstants";
import { debugError, debugLog } from "../../../utils";
import { errorToastMessages, isUserCancellation, showErrorCard, showErrorToast } from "../../../errorsurfaces";

export default class extends Controller {
  static values = {
    disableDuration: 30,
    permit: String,
    chainid: Number,
    session: String,
  }

  async connect() {
    this.permit = JSON.parse(this.permitValue);

    const walletClient = walletService.getWalletClient();

    if (walletClient) {
      const current_chain = walletService.getCurrentChain();

      if (current_chain != null) {
        let chainId = parseInt(current_chain.id, 16);

        if (chainId != this.chainidValue) {
          debugLog("Connected Chain", chainId, "is not on desired network: ", this.chainidValue);
          await walletService.changeChains(this.chainidValue);
        }
      }
    }
    
    this.hideLoadingScreen();
  }

  async authorise() {
    this.showLoadingScreen();
    this.disableInteractionForDuration();
    const walletClient = walletService.getWalletClient();

    debugLog("Authorisation3rdPartyWithPermitSupportController PermitData", this.permit);

    if (walletClient) {
      const data = this.permit;
      let permitSignature;
      try {
        permitSignature = await walletClient.signTypedData({
          domain: data.domain,
          message: data.message,
          primaryType: data.primaryType,
          types: data.types,
        });
      } catch (error) {
        emitCheckoutEvent("checkout_cw_tx_rejected", {
          wallet_provider: walletService.getConnectedWalletLabel() || "",
        });
        debugError("Authorisation3rdPartyWithPermit signTypedData rejected", error?.message || error);
        this.hideLoadingScreen();
        if (isUserCancellation(error)) {
          showErrorToast(errorToastMessages.paymentDeclinedInWallet);
        } else {
          showErrorCard("something-went-wrong", { session: this.sessionValue });
        }
        return;
      }

      emitCheckoutEvent("checkout_cw_tx_approved", {
        network: walletService.getChain(this.chainidValue)?.name || String(this.chainidValue || ""),
        amount_crypto: String(data.message?.value ?? ""),
      });

      data.rawSignature = permitSignature;
      data.signature = parseSignature(permitSignature);

      // Convert v and yParity to strings
      data.signature.v = data.signature.v.toString();
      data.signature.yParity = data.signature.yParity.toString();

      data.address = walletService.getWalletAddress();
      data.session = this.sessionValue;

      const form = document.getElementById("frame-post-form");
      form.action = `/${sessionStorage.getItem(storage.CODE)}/authorized-3rdParty-review/`;

      document.getElementById("form_address").value = data.address;
      document.getElementById("form_domain").value = JSON.stringify(data.domain);
      document.getElementById("form_message").value = JSON.stringify(data.message);
      document.getElementById("form_primaryType").value = data.primaryType;
      document.getElementById("form_signature").value = JSON.stringify(data.signature);
      document.getElementById("form_rawSignature").value = data.rawSignature;
      document.getElementById("form_types").value = JSON.stringify(data.types);
      document.getElementById("form_session").value = data.session;

      form.requestSubmit();
    }
  }

  disableInteractionForDuration() {
    const self = this;
    let remaining = this.disableDurationValue;

    self.disableInterval = setInterval(function() {
      remaining = remaining - 1;
      self.updateLoadingScreenMessage(`Please wait for ${remaining} second${remaining < 2 ? '' : 's'} before trying again.`);

      if (remaining === 0) {
        self.hideLoadingScreen();
        clearInterval(self.disableInterval);
      }
    }, 1000);
  }

  updateLoadingScreenMessage(text) {
    this.dispatch("updateLoadingScreenMessage", { detail: { text } });
  }

  showLoadingScreen() {
    this.dispatch("showLoadingScreen", { detail: { text: "Please Wait" } });
  }

  hideLoadingScreen() {
    this.dispatch("hideLoadingScreen");
  }
}
